import { useStaticQuery, graphql } from 'gatsby'

export const getPartnerHeroData = () => {
  const { allStrapiCommonHero } = useStaticQuery(partnerHeroDataQuery)
  let partnerHeroData = allStrapiCommonHero.nodes[0].Heros.filter(
    value => Object.keys(value).length !== 0
  )
  return partnerHeroData[0]
}

const partnerHeroDataQuery = graphql`
  query {
    allStrapiCommonHero {
      nodes {
        Heros {
          ... on STRAPI__COMPONENT_SHARED_PARTNER_HERO {
            id
            button {
              id
              name
              url
            }
            description {
              data {
                description
              }
            }
            title
          }
        }
      }
    }
  }
`
